import styles from "./Footer.module.scss";
import LongLogo from "../../assets/longlogo-white.png";
import { ReactComponent as MailIcon } from "../../assets/mail.svg";
import { ReactComponent as FacebookIcon } from "../../assets/facebook.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/linkedin.svg";

const Footer = () => (
  <footer className={styles.wrapper}>
    <img src={LongLogo} width="277" alt="long-logo" />
    <div className={styles.icons}>
      <a href="mailto:tonjekrosso@hotmail.com">
        <MailIcon />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.linkedin.com/in/tonje-kross%C3%B8y-2732961b7/"
      >
        <LinkedinIcon />
      </a>
    </div>
  </footer>
);

export default Footer;
